var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCabletv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 52.5C13.625 52.5 12.4479 52.0104 11.4688 51.0312C10.4896 50.0521 10 48.875 10 47.5V17.5C10 16.125 10.4896 14.9479 11.4688 13.9688C12.4479 12.9896 13.625 12.5 15 12.5H55C56.375 12.5 57.5521 12.9896 58.5312 13.9688C59.5104 14.9479 60 16.125 60 17.5V47.5C60 48.875 59.5104 50.0521 58.5312 51.0312C57.5521 52.0104 56.375 52.5 55 52.5H45V55C45 55.7083 44.7604 56.3021 44.2812 56.7812C43.8021 57.2604 43.2083 57.5 42.5 57.5H27.5C26.7917 57.5 26.1979 57.2604 25.7188 56.7812C25.2396 56.3021 25 55.7083 25 55V52.5H15ZM15 47.5H55V17.5H15V47.5Z",
    fill: "#031273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabletv);
export default __webpack_public_path__ + "static/media/cabletv.c8278e4a787ac80f061edf5215459490.svg";
export { ForwardRef as ReactComponent };